// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

// Action Types/
import { actions } from '../';

// Selectors
import { getSnapshotIndexById, getSnapshotsWithIdRemoved } from './selectors';

// Utils
import { doZoneSetsHaveUniqueGeometry } from 'util/zoneUnique';

export const snapshotIds = [
  'DRAW_START' // used to track the start of the last drawing operation.
].reduce((result, key) => { result[key] = key; return result; }, {});

// Reducer
export default function reducer( // NOSONAR False-Positive, Reducer Exception
  state = [],
  action = {}
) {
  switch (action.type) {
    case actions.ZONE_HISTORY_POP: // Call selector to get value before popping.
      return state.length > 1 ? state.slice(0, state.length - 1) : [];

    case actions.ZONE_HISTORY_PUSH:
    {
      const newState = getSnapshotsWithIdRemoved(state, action.payload.snapshotId);
      const newSnapshot = {zones:action.payload.zones, id:action.payload.snapshotId};
      // If the last snapshot is not geometrically different than this new one, replace it with the newer snapshot,
      // which may contain updated non-geometric data, e.g. population. The history should only contain snapshots
      // that show drawing changes to avoid clicking on "undo" and having no apparent change. The one exception is the
      // very first snapshot, which corresponds to the initial loaded state of the script.
      if (newState.length > 1
            && !doZoneSetsHaveUniqueGeometry(newState[newState.length-1].zones, newSnapshot.zones)) {
        newState[newState.length-1] = newSnapshot;
      } else {
        newState.push(newSnapshot);
      }
      return newState;
    }

    case actions.ZONE_HISTORY_INIT:
      return [{zones: action.payload.zones}];

    case actions.ZONE_HISTORY_REVERT_TO_SAVED:
      return (state.length > 0) ? [state[0]] : []; // First element is snapshot of initial zones when script was first loaded.

    case actions.ZONE_HISTORY_REVERT_TO_SNAPSHOT:
      let revertToIndex = getSnapshotIndexById(state, action.payload.snapshotId);
      if (state.length === 0 || revertToIndex === -1) { return state.slice(); }
      return state.slice(0,revertToIndex+1);

    default:
      return state;
  }
}

// Action Creators - see parent duck
